export default __webpack_public_path__ + "static/media/simboloLogoBranca.186fd090.PNG";